import React, { useRef } from "react";
import {
  Input,
  Form,
  DatePicker,
  Select,
  Switch,
  Button,
  TimePicker,
  InputNumber,
  Empty,
} from "antd";
import "./RoundedFormItems.scss";
import IMask from "imask";

import moment from "moment";

const DATE_FORMAT = "MM/DD/YYYY";
const MASKED = IMask.createMask({
  blocks: {
    DD: { from: 1, mask: IMask.MaskedRange, to: 31 },
    MM: { from: 1, mask: IMask.MaskedRange, to: 12 },
    YYYY: { from: 1900, mask: IMask.MaskedRange, to: Number.MAX_VALUE },
  },
  format: (date) => moment(date).format(DATE_FORMAT),
  mask: Date,
  parse: (date) => moment(date, DATE_FORMAT),
  pattern: DATE_FORMAT,
});

const FormItem = Form.Item;
const { Option } = Select;
const { TextArea } = Input;

export const FormInput = ({
  name,
  required,
  type,
  label,
  placeholder,
  initialValue,
  styles,
  disabled,
  max,
  hidden,
  shouldUpdate,
  rules,
  onChange,
  className = "",
  addonAfter,
  onBlur,
}) => {
  return (
    <FormItem
      shouldUpdate={shouldUpdate}
      hidden={hidden}
      className={`noError roundedSelect ${className}`}
      style={{
        border: "2px solid #DBDFEA",
        margin: "8px 10px",
        borderRadius: 14,
      }}
      initialValue={initialValue}
      label={label}
      name={name}
      rules={
        rules ?? [
          {
            required,
            message: "*Required",
          },

          {
            type: type === "email" ? "email" : null,
            message: "The input is not valid E-mail!",
          },
        ]
      }
      onChange={onChange}
    >
      <Input
        addonAfter={addonAfter}
        placeholder={placeholder}
        className="roundedFormItem input"
        style={{ ...styles, border: "none", fontSize: 20 }}
        type={type === "email" ? "text" : type}
        disabled={disabled}
        maxLength={max}
        autoComplete="do-not-autofill"
        onBlur={onBlur}
      />
    </FormItem>
  );
};
export const FormInputNumber = ({
  name,
  required,
  type,
  label,
  placeholder,
  initialValue,
  styles,
  disabled,
  max,
  maxlength,
}) => {
  return (
    <FormItem
      initialValue={initialValue}
      label={label}
      name={name}
      rules={[
        {
          required,
          message: "*Required",
        },
      ]}
    >
      <InputNumber
        placeholder={placeholder}
        className="roundedFormItem"
        style={styles}
        disabled={disabled}
        max={max}
        maxLength={maxlength}
      />
    </FormItem>
  );
};
export const FormDatePicker = ({
  name,
  required,
  label,
  initialValue,
  styles,
  onClick,
  disabled,
  disabledDate,
  dependencies,
  onChange,
  form,
}) => {
  return (
    <FormItem
      style={{
        border: "2px solid #DBDFEA",
        flex: 1,
        margin: "8px 10px",
        borderRadius: 14,
      }}
      initialValue={initialValue}
      label={label}
      name={name}
      dependencies={dependencies}
      className="noError roundedSelect "
      rules={[
        {
          required: true,
          message: "Please input task",
        },
      ]}
      onKeyUp={(e) => {
        if (
          e.target.value === "" ||
          e.target.value === null ||
          e.target.value === undefined
        ) {
          form.setFieldsValue({
            [name]: undefined,
          });
          onChange?.(undefined);
        }
      }}
    >
      <DatePicker
        format={DATE_FORMAT}
        onKeyDown={(event) => {
          let inputValue = event.target.value;
          let inputValueWithKey = inputValue + event.key;
          const target = event.target;
          const regex = /^\d{2}\/\d{2}\/\d{4}$/g;

          let newValue = MASKED.resolve(inputValue);
          let newValueWithKey = newValue + event.key;

          target.value = newValue;

          if (newValueWithKey.match(regex) && form) {
            const date = moment(newValueWithKey, DATE_FORMAT);
            if (!(disabledDate && disabledDate(date))) {
              form.setFieldsValue({
                [name]: date,
              });
              onChange?.(date);
              event.preventDefault();
            }
          }
        }}
        onChange={(date, dateString) => {
          form.setFieldsValue({
            [name]: date,
          });
          onChange?.(date);
        }}
        placeholder={DATE_FORMAT.toLowerCase()}
        disabled={disabled}
        disabledDate={disabledDate}
        // onClick={onClick}
        className="home_select"
        style={{
          ...styles,
          marginRight: 12,
          borderRadius: 14,
          width: "100%",
          paddingBottom: 12,
          fontSize: 18,
        }}
      />
    </FormItem>
  );
};
export const FormTimePicker = ({
  name,
  required,
  label,
  initialValue,
  styles,
  disabled,
}) => {
  return (
    <FormItem
      initialValue={initialValue}
      label={label}
      name={name}
      rules={[
        {
          required,
          message: "Please input task",
        },
      ]}
    >
      <TimePicker
        className="roundedFormItem"
        format={"HH:mm"}
        style={styles}
        disabled={disabled}
      />
    </FormItem>
  );
};

export const FormSelect = ({
  name,
  required,
  label,
  placeholder,
  options,
  initialValue,
  styles,
  onChange,
  disabled,
  dropdownStyle,
  mode,
  onClick,
  renderLabel,
  renderValue,
  suffixIcon,
  emptyMessage = "No Data",
  rules,
  dropdownClassName,
  dependencies,
  loading,
  hidden,
}) => {
  const ref = useRef();

  return (
    <FormItem
      style={{
        flex: 1,
        margin: "8px 10px",
        borderRadius: 14,
      }}
      label={label}
      initialValue={initialValue}
      name={name}
      className="roundedSelect noError"
      validateFirst
      rules={
        rules ?? [
          {
            required,
            message: false,
          },
        ]
      }
      dependencies={dependencies}
      hidden={hidden}
    >
      <Select
        disabled={disabled}
        loading={loading}
        virtual={false}
        ref={ref}
        onClick={onClick && onClick}
        mode={mode && mode}
        dropdownStyle={{ borderRadius: 14, ...dropdownStyle }}
        className={`home_select hideValue  ${
          options.length > 0 ? "showValue" : ""
        } `}
        dropdownClassName={dropdownClassName}
        placeholder={placeholder}
        style={styles}
        onChange={onChange}
        suffixIcon={suffixIcon}
        notFoundContent={
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={emptyMessage}
          />
          // <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          //   <img src={Empty.PRESENTED_IMAGE_SIMPLE} />
          //   <p style={{ margin: 0 }}>No data</p>
          // </div>
        }
      >
        {options?.map?.((opt) => (
          <Option
            disabled={opt?.disabled}
            key={renderValue ? opt[renderValue] : opt}
            value={renderValue ? opt[renderValue] : opt}
          >
            {renderLabel ? opt[renderLabel] : opt}
          </Option>
        ))}
      </Select>
    </FormItem>
  );
};

export const FormSwitch = ({ name, required, label, initialValue }) => {
  return (
    <FormItem
      initialValue={initialValue}
      label={label}
      name={name}
      valuePropName="checked"
      rules={[
        {
          required,
          message: "Please input task",
        },
      ]}
    >
      <Switch />
    </FormItem>
  );
};
export const FormHiddenSubmitButton = ({ submitRef }) => {
  return (
    <Form.Item
      style={{ display: "none" }}
      wrapperCol={{
        offset: 8,
        span: 16,
      }}
    >
      <Button ref={submitRef} type="primary" htmlType="submit"></Button>
    </Form.Item>
  );
};

export const FormInputArea = ({
  name,
  required,
  label,
  placeholder,
  message,
  initialValue,
  styles,
}) => {
  return (
    <FormItem
      initialValue={initialValue}
      label={label}
      name={name}
      rules={[
        {
          required,
          message: "*Required",
        },
      ]}
    >
      <TextArea placeholder={placeholder} style={styles} />
    </FormItem>
  );
};
